// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3Ilaf","resendInfoText":"OnGoingPaymentBox_resendInfoText__1qILf"};